<div class="bg-white rounded mb-3">
  <div class="border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2">{{editMode? 'Edit': 'Add'}} Role</h3>
    </div>
  </div>
  <form *ngIf="addRoleForm" class="kt-form" [formGroup]="addRoleForm" (submit)="onSubmit()">
    <div class="p-4">
      <div class="row">
        <div class="col-md-6">
          <label>Role Name <span class="text-danger">*</span></label>
          <input type="text" placeholder="Enter Role Name here" formControlName="roleName" class="form-control" />
          <p class="text-danger"></p>
        </div>
        <div class="col-md-6">
          <label>Role type <span class="text-danger">*</span></label>
          <select [disabled]="editMode" formControlName="userType"
                  (change)="typeChanged($event.target.value)" placeholder="Role Type" class="form-control form-select">
            <option hidden [value]="" [selected]="!addRoleForm.value.userType">Role Type</option>
            <option value="Admin" *ngIf="adminPermission"
                    [selected]="addRoleForm.value.userType == 'Admin'">
              Admin
            </option>
            <option value="Seller" *ngIf="sellerPermission"
                    [selected]="addRoleForm.value.userType == 'Seller'">
              Seller
            </option>
          </select>
        </div>
        <div class="row mb-3" *ngIf="addRoleForm.value.userType == 'Seller'">
          <div class="col-lg-4 d-flex flex-column align-items-start">
            <label>Temp Role (Hide From Seller)</label>
          </div>
          <div class="col-lg-4 d-flex flex-column align-items-start">
            <mat-radio-group formControlName="temp">
              <mat-radio-button [value]="true" class="me-3">{{ 'Sellers.Products.Yes' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false">{{ 'Sellers.Products.No' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="col-md-6 pt-2">
          <label>Select Role permissions: <span class="text-danger">*</span></label>
          <mat-selection-list formControlName="permissions">
            <mat-list-option *ngFor="let permission of permissions" [value]="permission.id">
              {{ permission.name }}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="col-12 d-flex justify-content-end">
          <button class="btn btn-primary col-auto mt-3" type="submit" [disabled]="addRoleForm.invalid">
            Submit
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
